export const asyncLoopSeq = async (
  asyncFn: (prop?: any) => Promise<any>,
  props: any[] = [],
): Promise<any[]> => {
  if (typeof asyncFn !== "function") return Promise.resolve([]);

  const res = [];
  for (const prop of props) {
    res.push(await asyncFn(prop));
  }

  return res;
};
